import { Typography, Grid2, Box } from "@mui/material";
import Styles from "./Mob.module.css"
import en from "../../../../i18n/English/Trade Invest/derivative.json";
import hi from "../../../../i18n/Hindi/Trade Invest/derivative.json";
import kn from "../../../../i18n/Kannada/Trade Invest/derivative.json";
import ma from "../../../../i18n/Marathi/Trade Invest/derivative.json";
import gu from "../../../../i18n/Gujarati/Trade Invest/derivative.json";
import { useLanguage } from "../../../../Context/LangContext";
export default function BenefitsWeb() {
    const { language } = useLanguage();
    const translations = { en, hi, kn, gu, ma };
    const t = translations[language];
    return (
        <>
            <Box className={Styles.outerBox}>


                <div className={Styles.headingContainer}>
                    <div className={Styles.gradientBackground}></div>
                    <h1 className={Styles.heading}>
                        {t.title}
                    </h1>
                </div>

                    <Grid2 className={Styles.txtCard}>
                        <Typography className={Styles.innertxt1} >
                            <span className={Styles.innertxtspan}>
                                •
                            </span>
                            <span className={Styles.innertxtWrapper}>
                            {t.points[0]}
                            </span>
                        </Typography>

                        <Typography className={Styles.innertxt1}>
                            <span className={Styles.innertxtspan}>
                                •
                            </span>
                            <span className={Styles.innertxtWrapper}>
                            {t.points[1]}
                            </span>
                        </Typography>

                        <Typography className={Styles.innertxt1}>
                            <span className={Styles.innertxtspan}>
                                •
                            </span>
                            <span className={Styles.innertxtWrapper}>
                            {t.points[2]}
                            </span>
                        </Typography>

                        <Typography className={Styles.innertxt1}>
                            <span className={Styles.innertxtspan}>
                                •
                            </span>
                            <span className={Styles.innertxtWrapper}>
                            {t.points[3]}
                            </span>
                        </Typography>

                        <Typography className={Styles.innertxt1}>
                            <span className={Styles.innertxtspan}>
                                •
                            </span>
                            <span className={Styles.innertxtWrapper}>
                            {t.points[4]}
                            </span>
                        </Typography>
                    </Grid2>




            </Box>
        </>
    )
}